import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input,
    OnInit,
} from '@angular/core';
import { NgbActiveModal, NgbModal } from '@cmps/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

import { TranslationKeyMap } from '../../coaching-insight.i18n';
import { Commitment, ElasticTabConfig } from '../models/oa.model';
import { CoachingInsightWidgetService } from '../services/coaching-insight.widget.service';

// import {HistoryFilterOptions} from './models/oa.global.model';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
interface CommitmentGroup {
    title: string;
    commitments: Commitment[];
    activeCommitment: number;
}

@Component({
    selector: 'person-oa-history',
    templateUrl: './person-oa-history.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PersonOAHistoryComponent implements OnInit {
    @Input() activeHistoryTab: string = 'tab-commitments';
    @Input() performerId: number;

    showHistoryFilter: boolean = false;
    numRecords: number = 10000;
    displayRecords: number = 10;

    displayedRecords: number = 0;
    totalRecords: number = 0;

    cFilter: any;
    oFilter: any;
    gFilter: any;

    i18n = TranslationKeyMap;

    placeholderText: string = this._translateService.instant(
        TranslationKeyMap._7448_PLEASE_SELECT_,
    );

    historyTabsConfig = [
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        <ElasticTabConfig>{
            text: this._translateService.instant(
                TranslationKeyMap._7453_COMMITMENTS,
            ),
            activeConditionComparator: 'tab-commitments',
            clickHandler: () => {
                this.activeHistoryTab = 'tab-commitments';
            },
        },
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        <ElasticTabConfig>{
            text: this._translateService.instant(TranslationKeyMap._7454_GOALS),
            activeConditionComparator: 'tab-goals',
            clickHandler: () => {
                this.activeHistoryTab = 'tab-goals';
            },
        },
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        <ElasticTabConfig>{
            text: this._translateService.instant(
                TranslationKeyMap._7377_OBSERVATIONS,
            ),
            activeConditionComparator: 'tab-observations',
            clickHandler: () => {
                this.activeHistoryTab = 'tab-observations';
            },
        },
    ];

    public ObservationFilterOptions: any = {
        SessionTypes: null,
        Observers: null,
        Statuses: null,
        Focuses: null,
    };

    public ObservationFilter: any = {
        sessionTypeId: null,
        observerId: null,
        subBehaviour: null,
        behaviour: null,
        statusId: null,
        focusId: null,
    };

    public CommitmentFilterOptions: any = {
        Behaviours: null,
        SubBehaviours: null,
        Coaches: null,
        SessionTypes: null,
        Statuses: null,
    };

    public CommitmentFilter: any = {
        behaviour: null,
        subBehaviour: null,
        coachId: null,
        sessionTypeId: null,
        statusId: null,
    };

    public GoalFilterOptions: any = {
        Metrics: null,
        Coaches: null,
        Creators: null,
        Statuses: null,
        Dispositions: null,
    };

    public GoalFilter: any = {
        metricId: null,
        coachId: null,
        creatorId: null,
        statusId: null,
        dispositionId: null,
    };

    constructor(
        private readonly _coachInsightService: CoachingInsightWidgetService,
        private readonly _modalService: NgbModal,
        public activeModal: NgbActiveModal,
        private readonly cd: ChangeDetectorRef,
        private readonly _translateService: TranslateService,
    ) {}

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    ngOnChanges(args) {
        // sort coommitments
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    ngOnInit() {
        //
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    showRecords(num) {
        this.displayRecords = num != null ? num : 10000;
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    toggleHistoryFilter(force?: boolean) {
        this.showHistoryFilter =
            force != null ? force : !this.showHistoryFilter;
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    emptyFilterOptions(obj) {
        const newobj = {};
        for (const key in obj) {
            newobj[key] = null;
        }
        return newobj;
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    handleDisplayedRecords(evt: number) {
        this.displayedRecords = evt;
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    handleTotalRecords(evt: number) {
        this.totalRecords = evt;
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    clearFilter(which) {
        switch (which) {
            case 'COMMITMENTS':
                this.cFilter = this.emptyFilterOptions(this.cFilter);
                this.CommitmentFilter = this.emptyFilterOptions(
                    this.CommitmentFilter,
                );
                break;
            case 'OBSERVATIONS':
                this.oFilter = this.emptyFilterOptions(this.oFilter);
                this.ObservationFilter = this.emptyFilterOptions(
                    this.ObservationFilter,
                );
                break;
            case 'GOALS':
                this.gFilter = this.emptyFilterOptions(this.gFilter);
                this.GoalFilter = this.emptyFilterOptions(this.GoalFilter);
                break;
        }
        setTimeout(() => this.cd.detectChanges());
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    filter(which) {
        switch (which) {
            case 'COMMITMENTS':
                this.cFilter = { ...this.CommitmentFilter };
                break;
            case 'OBSERVATIONS':
                this.oFilter = { ...this.ObservationFilter };
                break;
            case 'GOALS':
                this.gFilter = { ...this.GoalFilter };
                break;
        }
    }
}
